// src/slices/podcast/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAllPodcasts, getPodcastById, getPodcastBySlug } from "./thunk";

const initialState = { list: [], singlePodcast: null, loading: false, error: null, Pagination: {} };

const podcastSlice = createSlice({
  name: "podcast",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder

      // Get All
      .addCase(getAllPodcasts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllPodcasts.fulfilled, (state, action) => {
        state.loading = false;

        const res = action.payload?.data;

        state.list = res?.data || [];

        state.Pagination = res?.responseDetails?.pagination || {};
      })
      .addCase(getAllPodcasts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get By ID
      .addCase(getPodcastById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPodcastById.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePodcast = action.payload?.data || action.payload;
      })
      .addCase(getPodcastById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get By Slug
      .addCase(getPodcastBySlug.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPodcastBySlug.fulfilled, (state, action) => {
        state.loading = false;
        state.singlePodcast = action.payload?.data || action.payload;
      })
      .addCase(getPodcastBySlug.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export default podcastSlice.reducer;
